var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "181",
        height: "136",
        viewBox: "0 0 181 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("rect", { attrs: { width: "181", height: "136", fill: "#96DE06" } }),
      _c("rect", {
        attrs: {
          x: "31",
          y: "23",
          width: "150",
          height: "113",
          fill: "#C6FB31",
        },
      }),
      _c("rect", {
        attrs: {
          x: "62",
          y: "46",
          width: "119",
          height: "90",
          fill: "#A9EA27",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }